import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-screen flex flex-col items-center justify-center bg-[#0B0F14] text-[#F5F1E8] px-6 text-center">
      <p className="text-sm tracking-[0.3em] text-[#C7A361] uppercase">404</p>
      <h1 className="font-display text-3xl sm:text-4xl mt-3">This page can't be found</h1>
      <p className="text-sm text-[#A8AFB8] mt-3 max-w-md">The link you followed may be outdated, or the page may have moved.</p>
      <Link data-testid="not-found-home-link" to="/" className="mt-8 inline-flex items-center rounded-full border border-[#C7A361] text-[#C7A361] px-6 py-2.5 text-sm hover:bg-[#C7A361] hover:text-[#0B0F14] transition-colors">
        Back to Home
      </Link>
    </div>
  );
}
